import { Text } from "@overmap-ai/blocks"
import type { IssueAssociation, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueAssociationListItem } from "./IssueAssociationListItem"

interface IssueAssociationListProps {
	issueAssociations: Stored<IssueAssociation>[]
	type: "asset" | "issue"
}

export const IssueAssociationList = memo<IssueAssociationListProps>((props) => {
	const { issueAssociations, type } = props

	return issueAssociations.length > 0 ? (
		<ul className="flex flex-col gap-2">
			{issueAssociations.map((issueAssociation) => (
				<IssueAssociationListItem
					key={issueAssociation.uuid}
					issueAssociationId={issueAssociation.uuid}
					type={type}
				/>
			))}
		</ul>
	) : (
		<Text accentColor="base" size="sm" weight="regular">
			{type === "issue" ? "No issues." : "No assets."}
		</Text>
	)
})
IssueAssociationList.displayName = "IssueAssociationList"
